<table class="table-responsive table-md">
  <thead>
    <tr>
      <th *ngFor="let column of columnsName">{{ column }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of jsonData">
      <td *ngFor="let column of columns; let i = index">
        <span class="responsive-title"> {{ columnsName[i] }}: </span>
        {{ row[column]?.value }}
      </td>
    </tr>
  </tbody>
</table>
